module.exports = __webpack_public_path__ + "static/media/housr-logo.941363e2.png";